import React from "react";

import { cn } from "../../utils/cn";

interface DividerProps {
    /**
     * Optional className for caller overrides — color (`bg-line-base` for
     * stronger contrast), spacing, or thickness (`h-0.5` for a thicker rule).
     * Tailwind utility wins over the defaults below.
     */
    className?: string;
}

/**
 * @version 2.0.0
 * @published 2026-04-27
 * @history
 *   2.0.0 — Dropped the `color` + `thickness` runtime props (no caller used
 *           them). Now a thin styled `<div>` with `h-px w-full bg-line-neutral`
 *           defaults; callers override via `className` (e.g.
 *           `className="bg-line-base"` for stronger contrast).
 *   1.0.0 — Initial publish. One-line horizontal rule used pervasively across
 *           the prototype pages (PortfolioCard, withdraw queue, transaction
 *           list, etc.).
 */
export function Divider({ className }: DividerProps): React.ReactElement {
    return <div className={cn("h-px w-full bg-line-neutral", className)} />;
}
